import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { RootStoreContext } from "../../stores/rootStore";

export const Navbar = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const { shopUID, currentShop, prevRoute } = rootStore.commonStore;
  const { user, isLoggedIn, isCustomer, logout, signIn } = rootStore.userStore;
  const { orderDetails } = rootStore.orderStore;
  const generateClassName = (route: string) => {
    let newclassName = orderDetails?.length > 0 ? 'disabled-link ' : '';
    if(prevRoute === route)
      newclassName = newclassName + 'selected'
    return newclassName
  }
  return (
    <nav>
      <ul className="navbar-nav">
        { isLoggedIn && isCustomer && (
        <>
          <li>
            <Link className={generateClassName('/order')}  to={ (currentShop?.itemSelectionOptions === 0 || user?.noItemSelect) ? "/basket" : "/order"}>Order Booking</Link>
          </li>
          <li>
            <Link className={generateClassName('/profile')}  to="/profile">My Details</Link>
          </li>
          {currentShop?.hasOrderTracking && (
          <li>
            <Link className={generateClassName('/myorders')} to="/myorders">My Orders</Link>
          </li>
          )}
          {(currentShop?.hasSubsciption && user?.hasRegularVisits) && (
          <li>
            <Link className={generateClassName('/mysubscriptions')} to="/mysubscriptions">My Collections</Link>
          </li>

          )}
          <li>
            <Link className={generateClassName('/myoffers')} to="/myoffers">My Offers</Link>
          </li>
        </>
        )}
        <li className="sm-only">
          <Link className={generateClassName('/terms')} to={"/terms"}>Terms &amp; Conditions</Link>
        </li>
        <li className="sm-only">
          <Link className={generateClassName('/privacy')} to={"/privacy"}>Privacy Policy</Link>
        </li>
        <li className="sm-only">
          <Link className={generateClassName('/faqs')} to={"/faqs"}>FAQs</Link>
        </li>
        <li className="sm-only">
          <Link className={generateClassName('/contactus')} to="/contactus">Contact Us</Link>
        </li>
      </ul>
      {isLoggedIn && isCustomer ? (
        <div className="navbar-logoff-wrapper">
        <Link to={`/${shopUID}`}>
          <button className="btn btn-navbar" onClick={logout}>
            Log Off
          </button>
        </Link>
        <span>{user?.displayName}</span>
        </div>
      ) : (
        <Link to={`/${shopUID}`}>
          <button className="btn btn-navbar" onClick={signIn} >Sign In</button>
        </Link>
      )}
    </nav>
  );
});
